export var apiPath='/v2/risk_profiles';var actionType='RISK_PROFILE';export default actionType;